import { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import i18n from 'i18next'
import { useAuth } from '../../components/auth/useAuth'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { getUnreadCount } from '../../actions/authActions'

export default function UserMenu() {
    const { t } = useTranslation()
    const storedLang = localStorage.getItem('csg-lang')
    const [lang, setLang] = useState(storedLang || 'es')

    const toggleLang = (e, newLang) => {
        e.stopPropagation()
        localStorage.setItem('csg-lang', newLang)
        setLang(newLang)
        i18n.changeLanguage(newLang)
    }
    const { clientauth, logoutClient } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const ref = useRef(null)
    const { avatar, unreadCount } = useSelector(state => state.auth)

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    useEffect(() => {
        dispatch(getUnreadCount())
    }, [dispatch, location.pathname])

    const displayName = clientauth?.name || 'Profesor'
    const displayEmail = clientauth?.email || ''
    const displayRole = t('admin.users.teacher')
    const avatarSrc = avatar || '/images/profile.svg'

    const menuItems = [
        {
            label: t('teacher.sidebar.profile'),
            desc: t('teacher.sidebar.profiledescription'),
            icon: 'fa-regular fa-user',
            to: '/teacher/profile',
            variant: 'primary'
        },
        {
            label: t('teacher.sidebar.classes'),
            desc: t('teacher.sidebar.classesdescription'),
            icon: null,
            imgSrc: '/images/openbook.svg',
            to: '/teacher/classes',
            variant: 'primary'
        },
        {
            label: t('teacher.sidebar.calendar'),
            desc: t('teacher.sidebar.calendardescription'),
            icon: null,
            imgSrc: '/images/calendar.svg',
            to: '/teacher/calendar',
            variant: 'primary'
        },
        {
            label: t('teacher.sidebar.communications'),
            desc: t('teacher.sidebar.communicationsdescription'),
            icon: null,
            imgSrc: '/images/chat.svg',
            to: '/teacher/communications',
            variant: 'primary'
        }
    ]

    return (
        <div className='user-menu-wrapper' ref={ref}>
            <div className='user-menu-trigger d-flex align-items-center gap-3' onClick={() => setOpen(!open)}>
                <div className='d-flex align-items-center gap-3'>
                    <div className='position-relative' style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); navigate('/teacher/communications') }}>
                        <i className="fa-regular fa-bell fs-5 text-dark"></i>
                        <span className='user-menu-badge' style={{ background: unreadCount > 0 ? '#dc2626' : '#9ca3af' }}>
                            {unreadCount > 99 ? '99+' : unreadCount}
                        </span>
                    </div>
                    <img src={avatarSrc} alt="avatar" className='user-menu-avatar' />
                    <div className='d-none d-md-block text-end'>
                        <p className='mb-0 fw-semibold text-dark' style={{ fontSize: '16px', lineHeight: 1.2 }}>{displayName}</p>
                        <p className='mb-0 text-muted' style={{ fontSize: '13px' }}>{displayRole}</p>
                    </div>
                </div>
            </div>

            {open && (
                <div className='user-menu-dropdown'>
                    <div className='user-menu-header'>
                        <div className='d-flex align-items-center gap-3'>
                            <img src={avatarSrc} alt="avatar" className='user-menu-header-avatar' />
                            <div className='text-white'>
                                <p className='mb-0 fw-bold' style={{ fontSize: '24px', lineHeight: 1.2 }}>{displayName}</p>
                                <p className='mb-0' style={{ fontSize: '16px', opacity: 0.9 }}>{displayEmail}</p>
                                <span className='user-menu-role-badge'>{displayRole}</span>
                            </div>
                        </div>
                    </div>

                    <div className='user-menu-body'>
                        {menuItems.map((item, i) => (
                            <Link key={i} to={item.to} className='user-menu-link' onClick={() => setOpen(false)}>
                                <div className='d-flex align-items-center gap-3 w-100'>
                                    <div className={`user-menu-icon user-menu-icon-${item.variant}`}>
                                        {item.imgSrc ? <img src={item.imgSrc} alt="" className='user-menu-svg-icon' /> : <i className={item.icon}></i>}
                                    </div>
                                    <div className='flex-grow-1'>
                                        <p className='mb-0 fw-semibold text-dark' style={{ fontSize: '15px' }}>{item.label}</p>
                                        <p className='mb-0 text-muted' style={{ fontSize: '13px' }}>{item.desc}</p>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>

                    <div className='user-menu-divider' />

                    <div className='d-flex align-items-center justify-content-center gap-1 py-2 px-3'>
                        <span onClick={(e) => toggleLang(e, 'es')} style={{ cursor: 'pointer', fontSize: '12px', fontWeight: lang === 'es' ? 700 : 400, color: lang === 'es' ? '#dc2626' : '#9ca3af', padding: '4px 8px', borderRadius: '6px', transition: 'all 0.2s' }}>{t('global.langes')}</span>
                        <span style={{ color: '#e5e7eb', fontSize: '12px' }}>|</span>
                        <span onClick={(e) => toggleLang(e, 'en')} style={{ cursor: 'pointer', fontSize: '12px', fontWeight: lang === 'en' ? 700 : 400, color: lang === 'en' ? '#dc2626' : '#9ca3af', padding: '4px 8px', borderRadius: '6px', transition: 'all 0.2s' }}>{t('global.langen')}</span>
                    </div>

                    <div className='user-menu-divider' />

                    <div onClick={() => { logoutClient(); navigate('/') }} className='user-menu-link user-menu-logout' style={{ cursor: 'pointer' }}>
                        <div className='d-flex align-items-center gap-3 w-100'>
                            <div className='user-menu-icon user-menu-icon-danger'>
                                <i className="fa-solid fa-arrow-right-from-bracket"></i>
                            </div>
                            <div>
                                <p className='mb-0 fw-semibold' style={{ fontSize: '15px', color: '#dc2626' }}>{t('signin.logout')}</p>
                                <p className='mb-0 text-muted' style={{ fontSize: '13px' }}>{t('signin.logoutDescription')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
